import { combineReducers } from "redux"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import globalLists from "./global/reducer"
import getuserData from "./users/reducer"
import getclientData from "./clients/reducer"
import getsiteData from "./sites/reducer"
import getManualURL from "./manageSite/reducer" 
import profileData from './auth/profile/reducer'
import manageUserData from './manageUser/reducer'

const rootReducer = combineReducers({
  Login,
  Account,
  ForgetPassword,
  globalLists,
  getuserData,
  profileData,
  manageUserData,
  getManualURL,
  getclientData,
  getsiteData
})

export default rootReducer
